function NXNetSale() {
  return (
    <svg
      width="54"
      height="51"
      viewBox="0 0 54 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="34" cy="20" r="20" fill="#E7F7EF" />
      <circle cx="11" cy="3" r="3" fill="#E7F7EF" />
      <path
        d="M7.34126 36.8773L14.8913 44.4273C17.9913 47.5273 23.0246 47.5273 26.1413 44.4273L33.4579 37.1106C36.5579 34.0106 36.5579 28.9773 33.4579 25.8606L25.8913 18.3273C24.3079 16.7439 22.1246 15.8939 19.8913 16.0106L11.5579 16.4106C8.22459 16.5606 5.57459 19.2106 5.40793 22.5273L5.00793 30.8606C4.90793 33.1106 5.75793 35.2939 7.34126 36.8773Z"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2246 31.3773C18.5258 31.3773 20.3913 29.5118 20.3913 27.2106C20.3913 24.9094 18.5258 23.0439 16.2246 23.0439C13.9234 23.0439 12.0579 24.9094 12.0579 27.2106C12.0579 29.5118 13.9234 31.3773 16.2246 31.3773Z"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22.0579 39.7106L28.7246 33.0439"
        stroke="#277200"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXNetSale;
